<template>
  <div id="Flex">
		<div class="topText">
			<h1>Welcome to Season Membership</h1>

			<p class="topLine"><span>Flexibility. Value. Priority Access to Tickets.<br />That's the promise of Rays Season Membership.</span></p>
			<p>Introducing the new way to support your American League Champion Tampa Bay Rays throughout the season! With Season Membership, you continue to receive the benefits of our most important stakeholders, while ensuring the flexibility to choose your games and seats throughout the 2021 regular season. Whether it's seats for two in the Rays Club or tickets for you and five friends in the Outfield, your seat location and quantity are up to you. Come join us!</p>
			<p>Please note, in order to accommodate socially-distant seating, traditional fixed seat locations are not available for the 2021 season. As we prepare to safely welcome fans back to Tropicana Field, a season membership ensures your priority as a Rays Season Member and provides early access to tickets for your choice of games.</p>
			<p><span>Flexibility</span> - Redeem your membership credit for as many games as you want to attend, one at a time or all at once, when you are ready. Use the credit on your account to buy any combination of tickets, up to six per game.</p>
			<p><span>Value</span> - Enjoy Season Member benefits and discounted ticket pricing with savings over single-game tickets.</p>
			<p><span>Priority Access to Tickets</span> - A season membership ensures your priority as a Rays Season Member and provides access to tickets ahead of the general public.</p>	
			<div class="renewBtn">
				<a v-scroll-to="'#Renew'">Renew Now</a>
			</div>
		</div>
		<b-container>
			<p class="smallPrint" style="text-align: center;">If you have a credit on your account, it can be applied to any of the Membership Levels below.</p>
			<table>
				<thead>
					<tr class="tableHeader">
						<th colspan="7">Rays Season Membership</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<th>Investment</th>
						<th>$500+</th>
						<th>$2,000+</th>
						<th>$4,000+</th>
						<th>$8,000+</th>
						<th>$12,000+</th>
						<th>$20,000+</th>
					</tr>
					<tr>
						<td>Ticket Discount Tier</td>
						<td>Bronze</td>
						<td>Bronze</td>
						<td>Silver</td>
						<td>Gold</td>
						<td>Gold</td>
						<td>Gold</td>
					</tr>
					<tr>
						<td>Available Seat Locations</td>
						<td><div class="square green"></div></td>
						<td><div class="square green"></div> <div class="square lightBlue"></div></td>
						<td><div class="square green"></div> <div class="square lightBlue"></div> <div class="square blue"></div></td>
						<td><div class="square green"></div> <div class="square lightBlue"></div> <div class="square blue"></div> <div class="square orange"></div></td>
						<td><div class="square green"></div> <div class="square lightBlue"></div> <div class="square blue"></div> <div class="square orange"></div> <div class="square yellow"></div></td>
						<td><div class="square green"></div> <div class="square lightBlue"></div> <div class="square blue"></div> <div class="square orange"></div> <div class="square yellow"></div> <div class="square black"></div></td>
					</tr>
					<tr>
						<td>Parking Discounts</td>
						<td><img src="@/assets/icons/logomark-alt.svg" /></td>
						<td><img src="@/assets/icons/logomark-alt.svg" /></td>
						<td><img src="@/assets/icons/logomark-alt.svg" /></td>
						<td><img src="@/assets/icons/logomark-alt.svg" /></td>
						<td><img src="@/assets/icons/logomark-alt.svg" /></td>
						<td>Complimentary</td>
					</tr>
					<tr>
						<td>Exclusive Presales</td>
						<td><img src="@/assets/icons/logomark-alt.svg" /></td>
						<td><img src="@/assets/icons/logomark-alt.svg" /></td>
						<td><img src="@/assets/icons/logomark-alt.svg" /></td>
						<td><img src="@/assets/icons/logomark-alt.svg" /></td>
						<td><img src="@/assets/icons/logomark-alt.svg" /></td>
						<td><img src="@/assets/icons/logomark-alt.svg" /></td>
					</tr>
				</tbody>
			</table>
			<!-- <p class="smallPrint">*Discounts will vary depending on games selected and Membership Level. Gold discounted ticket pricing will be the largest discount, followed by Silver, then Bronze.</p> -->
		</b-container>
  </div>
</template>

<script>
export default {
  name: "Flex"
}
</script>

<style lang="scss" scoped>
#Flex {
  text-align: center;
  margin: auto;
	margin-bottom: 100px;
	.topText {
		width: 50%;
		margin: auto;
		@media only screen and (max-width: $lg) {
      width: 80%;
    }
		h1 {
			font-family: 'UniversLTStd-UltraCn';
			text-transform: uppercase;
			color: $dark-blue;
			font-size: 50px;
			@media only screen and (max-width: $sm) {
				font-size: 42px;
			}
		}
		p {
			font-family: 'UniversLTStd';
			margin: 15px 0;
			text-align: justify;
			text-justify: inter-word;
			&.topLine {
				text-align: center;
			}
			span {
				font-family: 'UniversLTStd-Bold';
			}
		}
		ul {
			font-family: 'UniversLTStd';
			margin: 15px 0;
			list-style: none;
			li {
				margin: 10px 0;
			}
			span {
				font-family: 'UniversLTStd-Bold';
			}
		}
		.renewBtn {
			margin: 50px 0;
			a {
				font-family: 'UniversLTStd-Bold';
				font-size: 16px;
				color: #000;
				background-color: $yellow;
				border-radius: 25px;
				padding: 15px 40px;
				text-transform: uppercase;
				cursor: pointer;
				&:hover {
					text-decoration: none;
				}
			}
		}
	}
	
	table {
		width: 100%;
		margin-top: 50px;
		font-family: 'UniversLTStd-Bold';
		font-size: 14px;
		thead {
			background-color: $dark-blue;
			color: #fff;
			font-size: 20px;
		}
		.tableHeader {
			padding: 25px 0;
			th {
				border-top-left-radius: 7px;
				border-top-right-radius: 7px;
			}
		}
		tr {
			height: 45px;
			td {
				border-left: 1px solid #fff;
				img {
					width: auto;
					margin: auto;
				}
				.square {
					display: inline-block;
					width: 20px;
					height: 20px;
					margin: auto;
					border: 1px solid #d9d9d9;
					position: relative;
					top: 5px;
					&.green {
						background-color: #005F35;
					}
					&.lightBlue {
						background-color: #79BDE8;
					}
					&.blue {
						background-color: #00285D;
					}
					&.orange {
						background-color: #F78F1E;
					}
					&.yellow {
						background-color: #FCD20B;
					}
					&.black {
						background-color: #050707;
					}
				}
			}
		}
		tr:nth-child(even) {
			background: #d9d9d9;
		}
	}
	.smallPrint {
		font-family: 'UniversLTStd-Obl';
		text-align: left;
		font-size: 14px;
		margin-top: 30px;
	}
}
</style>